import SisuForm from './SisuForm';
import SisuFormContainer from './SisuForm.container';
export default SisuFormContainer(SisuForm);
